import React from 'react';
import {Box, Button, Container, TextField, Typography} from "@mui/material";
import {useNotification} from "../../utils/hooks/useNotification";
import {passwordResetRequestSchema, PasswordResetSchema} from "../../schemas/auth/passwordResetSchema";
import {zodResolver} from "@hookform/resolvers/zod";
import {useForm} from "react-hook-form";
import {postFetcher} from "../../utils/api/fetchers";
import {useNavigate} from "react-router-dom";

const ResetPasswordRequest: React.FC = () => {
    const {showNotification} = useNotification();
    const navigate = useNavigate();
    const {register, handleSubmit, formState: {errors}} = useForm<PasswordResetSchema>({
        resolver: zodResolver(passwordResetRequestSchema)
    });

    const onSubmit = (data: PasswordResetSchema) => {
        postFetcher("/auth/reset-password-request", data)
            .then(() => {
                showNotification("Žádost o obnovu hesla byla odeslána", "success");
                navigate("/");
            })
            .catch(error => {
                console.error(error);
                if (error.response?.status === 404) {
                    showNotification("Uživatelský účet s takovýmto emailem neexistuje", "error");
                } else {
                    showNotification("Došlo k chybě při odesílání žádosti o obnovu hesla", "error");
                }
            });
    };

    return (
        <Container component="main" maxWidth="md" sx={{padding: {xs: 2, sm: 4}, width: '100%'}}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    mt: 8,
                    boxShadow: 5,
                    padding: {xs: 2, sm: 6},
                    borderRadius: 2,
                    backgroundColor: 'white',
                }}
            >
                <Typography component="h1" variant="h5">
                    Žádost o obnovu hesla
                </Typography>
                <Box
                    onSubmit={handleSubmit(onSubmit)}
                    component="form"
                    noValidate
                    sx={{mt: 3, width: '100%'}}
                >
                    <Typography variant="body1" sx={{mt: 2, textAlign: 'center', color: 'gray'}}>
                        Zadejte svůj email, na který Vám zašleme odkaz pro obnovu hesla.
                    </Typography>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        label="Email"
                        autoComplete="email"
                        autoFocus
                        {...register('email')}
                        error={!!errors.email}
                        helperText={errors.email?.message}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        sx={{mt: 3, mb: 2, fontWeight: 'bold'}}
                    >
                        Potvrdit
                    </Button>
                </Box>
            </Box>
        </Container>
    );
};

export default ResetPasswordRequest;
